<template>
  <div class="productBox">
    <p class="title">온라인 스토어</p>
    <swiper class="swiper" ref="productSwiper" :options="swiperOption">
      <swiper-slide
        v-for="(item, index) in list"
        :key="index"
        class="slide">
        <a :href="item.content" target="_blank">
          <div class="img">
            <img :src="item.thumb" :alt="item.name">
          </div>
          <div class="info">
            <p class="name">{{item.name}}</p>
            <p class="price">{{item.price}}<span>원</span></p>
          </div>
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'
import {comma} from '@/lib';

export default {
  name : 'Shop',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        /*slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 15,
        slidesPerGroup: 4,*/
        breakpoints: {
          '300': {
            slidesPerView: 2,
            slidesPerColumn: 2,
            spaceBetween: 15,
            slidesPerGroup: 4,
          },
          '461': {
            slidesPerView: 3,
            slidesPerColumn: 1,
            spaceBetween: 21,
            slidesPerGroup: 1,
          },
          '961': {
            slidesPerView: 3.5,
            slidesPerColumn: 1,
            spaceBetween: 21,
            slidesPerGroup: 1,
          },
          '1000': {
            slidesPerView: 3.8,
            slidesPerColumn: 1,
            spaceBetween: 21,
            slidesPerGroup: 1,
          },
          '1500': {
            slidesPerView: 3.7,
            slidesPerColumn: 1,
            spaceBetween: 21,
            slidesPerGroup: 1,
          }
        }
      },
      swiperPause: false,
      list: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init() {
      const {data} = await this.$http.get('/shop/goods?limit=10')
      if (data.success) {
        this.list = data.data;

        this.list.map((item) => {
          item.price = comma(item.price);
        })
      }
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/product/'+imgSrc);
    }
  }
}
</script>
